import {
  hexToRgb
} from 'helpers/colors';

import colors from 'constants/colors';

angular.module('gym.components').directive('trainerEvent', ["$rootScope", "ContrastColor", function($rootScope, ContrastColor) {
  return {
    restrict: 'EA',
    template: require('templates/components/calendar/trainer_event.html.slim'),
    replace: true,
    scope: {
      event: '=',
      isAvailability: '=',
      showCancelledBadge: '='
    },
    link: function($scope) {
      var bgColor, date, eventColor, gymConfig, parseEventTime, ref, startTime;
      gymConfig = $rootScope.gym.gym_config;
      startTime = ((ref = gymConfig.calendar_display_hours_override) != null ? ref[0] : void 0) || 4;
      date = moment($scope.event.start, 'YYYY/MM/DD HH:mm').startOf('day').add(startTime, 'hours');
      parseEventTime = function(time) {
        return moment(time, 'YYYY/MM/DD HH:mm');
      };
      $scope.event.startMoment = parseEventTime($scope.event.start);
      $scope.event.endMoment = parseEventTime($scope.event.end);
      $scope.formatEventTime = function(time) {
        return time.format('h:mma');
      };
      bgColor = function(color) {
        var rgb;
        if (!$scope.isAvailability) {
          rgb = hexToRgb(color || colors.primary) || hexToRgb(colors.primary);
          return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
        }
      };
      $scope.eventColor = eventColor = function(color) {
        if (!$scope.isAvailability) {
          return color || colors.primary;
        }
      };
      $scope.fontColor = function(color) {
        if (!$scope.isAvailability) {
          return ContrastColor.get(eventColor(color), {
            darkColor: '#303030'
          });
        }
      };
      $scope.isFull = function() {
        if (!$scope.isAvailability) {
          return typeof $scope.event.vacancies_count === 'number' && $scope.event.vacancies_count <= 0;
        }
      };
      $scope.hasNote = function() {
        var ref1;
        if (!$scope.isAvailability) {
          return !!((ref1 = $scope.event.notes) != null ? ref1.length : void 0);
        }
      };
      $scope.getTitle = function() {
        var endTime;
        if ($scope.isAvailability) {
          startTime = $scope.formatEventTime($scope.event.startMoment);
          endTime = $scope.formatEventTime($scope.event.endMoment);
          return `${$scope.event.user_name}'s availability: ${startTime} - ${endTime}`;
        }
      };
      $scope.eventStyle = function() {
        var duration, event, minutesFromStartOfDay, minutesInTimeSlot, style, timeSlotHeight;
        timeSlotHeight = 25;
        minutesInTimeSlot = 30;
        event = $scope.event;
        minutesFromStartOfDay = event.startMoment.diff(date, 'minutes');
        duration = event.endMoment.diff(event.startMoment, 'minutes');
        return style = {
          top: `${minutesFromStartOfDay / minutesInTimeSlot * timeSlotHeight + timeSlotHeight}px`,
          height: `${duration / minutesInTimeSlot * timeSlotHeight}px`,
          'background-color': $scope.isAvailability ? 'transparent' : event.isCancelled ? '#9E9E9E' : '#fff',
          color: event.isCancelled ? '#FFFFFF' : $scope.fontColor(event.color)
        };
      };
      return $scope.eventInnerStyle = function() {
        var style;
        return style = {
          'background-color': $scope.event.isCancelled ? '#9E9E9E' : bgColor($scope.event.color)
        };
      };
    }
  };
}]);
